import {useEffect, useRef} from 'react'

export type OnDownloadEvent = () => void

interface DownloaderProps {
    blob: Blob,
    filename: string,
    onDownload: OnDownloadEvent
}

export const Download = ({blob, filename, onDownload} : DownloaderProps ) =>
{
    const link = useRef<HTMLAnchorElement>(null);
    const url = URL.createObjectURL(blob);

    useEffect(() =>
    {
        link?.current?.click();

        onDownload();

        return () => {
            // cleanup blob
            URL.revokeObjectURL(url);
        }
    }, [url, onDownload])

    return (
        <a ref={link} href={url} download={filename} className="d-none">
            Hidden download link
        </a>
    )
}
